import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NzModalRef} from "ng-zorro-antd/modal";

export interface ConfirmModalTopIcon {
  name: string;
  color: string;
  backgroundColor: string;
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.less'
})
export class ConfirmModalComponent {

  @Input() topIcon: ConfirmModalTopIcon | undefined;
  @Input() title: string = '¿Confirmar eliminación?';
  @Input() content: string = 'Esta acción eliminará permanentemente el usuario seleccionado y todos sus datos asociados.';
  @Input() confirmText: string = 'Eliminar usuario';
  @Input() cancelText: string = 'Cancelar';
  @Input() type: 'delete' | 'confirm' | undefined;
  @Input() loading: boolean = false;
  @Input() showFixedMsg: boolean = true;

  @Output() confirm = new EventEmitter<void>();

  constructor(private modalRef: NzModalRef) {
  }

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.close();
  }

  close() {
    this.modalRef.close();
  }
}
